import overSome from 'lodash-es/overSome';

import isUserAdmin from './isUserAdmin';
import isUserStripcashManager from './isUserStripcashManager';
import isUserCustomManager from './isUserCustomManager';

const isUserAnyManager = overSome([
  isUserAdmin,
  isUserStripcashManager,
  isUserCustomManager,
]);

export default isUserAnyManager;
